import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";
import Select from "react-select";
import { CentralesInterface } from "../../../../interfaces/CentralesInterface";
import { useGetData } from "../../../../hooks/useGetData";
import { toast } from "react-toastify";

/**
 * ClienteCrear Component
 * @description: Componente que permite agregar un nuevo cliente.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de clientes.
 */

const ClienteCrear = () => {
  const [show, setShow] = useState(false);
  const { data: centrales } = useGetData("/central?estatus[eq]=1", "centrales");
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();

  const [central, setCentral] = useState<number>();

  //Formulario
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      razon_social: "",
      nombre_comercial: "",
      codigo_sap: "",
      estatus: "1",
    },
  });

  //Función que hace el POST para crear el cliente.
  const createCliente = (data: any) => {
    if (!central) {
      toast.error("Se debe seleccionar una central", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    sendRequest(
      {
        url: `/cliente`,
        method: "POST",
        body: { ...data, central },
      },
      (variable: any) => {
        setShow(true);
        reset({
          razon_social: "",
          nombre_comercial: "",
          estatus: "1",
        });
      }
    );
  };

  return (
    <Container>
      <h1>Agregar cliente</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Cliente agregado"
          body="El cliente ha sido agregado de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(createCliente)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="6" className="mb-3">
            <Form.Label>Razón Social</Form.Label>
            <Controller
              name="razon_social"
              control={control}
              rules={{
                required: true,
                maxLength: 100,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.razon_social && (
              <Form.Text style={{ color: "red" }}>
                La razón social es obligatoria y no puede ser mayor a 100
                caracteres.
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group as={Col} md="6" className="mb-3">
            <Form.Label>Nombre Comercial</Form.Label>
            <Controller
              name="nombre_comercial"
              control={control}
              rules={{
                required: true,
                maxLength: 100,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre_comercial && (
              <Form.Text style={{ color: "red" }}>
                El nombre comercial es obligatorio y no puede ser mayor a 100
                caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md="6" className="mb-3">
            <Form.Label>Codigo SAP</Form.Label>
            <Controller
              name="codigo_sap"
              control={control}
              rules={{
                required: true,
                maxLength: 8,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.codigo_sap && (
              <Form.Text style={{ color: "red" }}>
                El codigo es obligatorio y no puede ser mayor a 8 caracteres.
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Central</Form.Label>
            <Select
              placeholder="Selecciona una opción"
              options={centrales?.map((central: CentralesInterface) => {
                return {
                  value: central.id,
                  label: central.nombre,
                };
              })}
              onChange={(central: any) => setCentral(central.value)}
            />
          </Form.Group>
        </Row>

        <Button
          style={{ backgroundColor: "#21618C", borderColor: "white" }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default ClienteCrear;
